import { useState, useRef } from "react";
import {
  Text,
  Icon,
  Button,
  Link,
  PaginationDots,
  Slider,
} from "@virkesborsen/ui-component-library";

const customerReviews = [
  {
    image: "img/drone/guy_in_front_of_timber.png",
    quote:
      "Jag kan verkligen rekommendera Treebula till andra skogsägare. Hela upplevelsen har varit väldigt positiv och jag kommer att använda Treebula igen.",
    name: "Mikael",
    profession: "Skogsägare, Sala",
    href: "/referenser/gor-som-skogsagaren-mikael-nar-du-ska-salja-virke/",
  },
  {
    image: "img/drone/guy_leaning_on_tree.jpg",
    quote:
      "Jag har alltid konkurrensutsatt mitt virke, så när jag fick möjligheten att göra detsamma med kolkrediter genom Treebula, kändes det självklart att testa. Kontakten var smidig och affären blev snabbt klar.",
    name: "Ola Strivall",
    profession: "Skogsägare, Nordanstig",
    href: "/referenser/ola-tjanar-pengar-pa-kolkrediter-genom-treebulas-tjanst-for-klimatkompensation/",
  },
  {
    image: "img/drone/guy_standing_next_to_timber.png",
    quote:
      "Jag rekommenderar alla skogsägare att använda Treebula, det är gratis och du har helt fri prövningsrätt, det vill säga är du inte nöjd med anbuden kan du bara tacka nej.",
    name: "Mårten Karlsson",
    profession: "Skogsägare, Årjäng",
    href: "/referenser/marten-valde-treebula-nar-han-skulle-salja-virke/",
  },
  {
    image: "img/drone/woman_in_pink_cap.jpg",
    quote:
      "Treebula gjorde det möjligt för oss att nå ut till fler aktörer än vi någonsin kunnat tidigare.",
    name: "Marianne Lindh",
    profession: "Skogsägare, Uppland",
    href: "/referenser/framgangsrik-avverkning-med-miljoner-i-vinst/",
  },
  {
    image: "img/drone/family_of_six.jpeg",
    quote:
      "För oss som förstagångssäljare var det ovärderligt att sälja via Treebula. Det hade varit svårt att sälja virke utan deras hjälp, med tanke på vår begränsade erfarenhet.",
    name: "Michael Hammars",
    profession: "Skogsägare, Värmland",
    href: "/referenser/fran-nyborjare-till-framgangsrik-virkesforsaljare/",
  },
];

export default function TreebulaReviews() {
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const sliderRef = useRef(null);

  const handlePrev = () => {
    const newIndex = sliderRef.current?.prev();
    if (newIndex !== undefined) {
      console.log("Prev", newIndex);
      setCurrentReviewIndex(newIndex);
    }
  };

  const handleNext = () => {
    const newIndex = sliderRef.current?.next();
    if (newIndex !== undefined) {
      setCurrentReviewIndex(newIndex);
    }
  };

  const handleDotSelect = (index) => {
    const newIndex = sliderRef.current?.scrollTo(index);
    if (newIndex) {
      setCurrentReviewIndex(newIndex);
    }
  };

  const goToLink = () => {
    window.location.href = "/referenser/";
  };

  return (
    <div className="h-full w-full bg-stone-50">
      <div className="max-w-[1320px] mx-auto flex flex-col">
        <section className="flex gap-8 rounded-xl overflow-hidden bg-stone-100 m-4 flex-col lg:m-16 lg:flex-row">
          <div className="flex-1 flex flex-col m-auto">
            <div className="mx-auto p-4 lg:max-w-12 lg:py-16 lg:max-w-96">
              <Text variant="calloutMediumMedium" className="mb-4">
                “Det var väldigt intressant att se skogen ovanifrån. Vi fick en
                helt ny bild av terrängen, och kunde upptäcka nya vindfällen som
                annars lätt missas.”
              </Text>
              <Text
                variant="introLeadMediumRegular"
                className="text-pebble-500 mb-12"
              >
                David använde Treebulas drönaranalys för att få en detaljerad
                överblick över sin fastighet – direkt integrerad i den digitala
                skogsbruksplanen.
              </Text>
              <Text
                variant="overlineLargeRegular"
                className="text-pebble-500 mb-6"
              >
                David, Skogsägare Norrtälje
              </Text>
              <Link
                tw
                href="/referenser/sa-fick-david-battre-koll-pa-sin-skog-med-hjalp-av-dronare/"
                target="blank"
                className="flex flex-row gap-2 items-center"
              >
                <Text variant="introLeadSmallRegular">Läs mer</Text>
                <Icon name="ArrowRightSimple" size="large" />
              </Link>
            </div>
          </div>

          <div className="flex-1">
            <img
              src={`${Window.static_path}img/drone/happy_guy_in_front_of_timber.jpeg`}
              alt="Glad skogsägare framför timmer – Treebula drönaranalys"
              className="w-auto h-full object-cover"
            />
          </div>
        </section>

        <section className="flex flex-col gap-8 m-4 lg:m-12 lg:gap-12">
          <div className="flex flex-col gap-4">
            <Text variant="sectionHeaderMedium">
              Vad säger våra kunder om oss.
            </Text>

            <Text variant="introLeadMediumRegular" className="text-pebble-500">
              Hör från våra fantastiska kunder som använder Treebula.
            </Text>
          </div>

          <div>
            <Slider ref={sliderRef} desktopVisible={4}>
              {customerReviews.map((item, index) => (
                <div key={index} className="flex-shrink-0 h-full cursor-pointer" onClick={() => goToLink(item.href)}>
                  <div className="flex flex-col rounded-xl overflow-hidden bg-charcoal-900/80 h-full">
                    <img
                      src={`${Window.static_path}${item.image}`}
                      alt="Skogsövervakning exempel"
                      className="h-[200px] object-cover w-full"
                    />
                    <div className="flex flex-col p-6 flex-grow">
                      <Text
                        variant="displayAndHeadlineLarge"
                        className="mb-[-20px] text-white-50"
                      >
                        ”
                      </Text>
                      <Text
                        variant="callout2XtraSmallMedium"
                        className="pb-4 text-white-50 flex-grow"
                      >
                        {item.quote}
                      </Text>
                      <div>
                        <Text
                          variant="labelMediumMediumDense"
                          className="pb-1 text-white-50"
                        >
                          {item.name}
                        </Text>
                        <Text
                          variant="labelSmallRegular"
                          className="text-white-50"
                        >
                          {item.profession}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <div className="flex justify-between items-center mt-8">
              <PaginationDots
                total={customerReviews.length - 3}
                activeIndex={currentReviewIndex}
                onDotSelect={handleDotSelect}
              />

              <div className="flex gap-3">
                <Button
                  tw
                  variant="secondary"
                  onClick={handlePrev}
                  disabled={currentReviewIndex === 0}
                  className="disabled:opacity-30"
                >
                  <Icon tw name="ArrowShortSimple" size="medium" />
                </Button>

                <Button
                  tw
                  variant="secondary"
                  onClick={handleNext}
                  disabled={
                    currentReviewIndex === sliderRef.current?.getMaxIndex()
                  }
                  className="disabled:opacity-30"
                >
                  <Icon
                    tw
                    name="ArrowShortSimple"
                    size="medium"
                    className="rotate-180"
                  />
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
